module.exports = __webpack_public_path__ + "static/img/10.429589f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/sp/10.png
// module id = ld/7
// module chunks = 0